import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v3/admin/customerList`;
export const QueryKey = () => ['v3', 'admin', 'customers'] as const;
export type Payload = never;
export type Response = Models.Customers.Customer[];
